export default __webpack_public_path__ + "9523ab4f2e3b576bbb4d1879960bea0e.svg";